import React,{useEffect} from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default function Resume() {
    useEffect(()=>{
        AOS.init({duration:1000})
    },[])
  return (
    <section className="resume-area page-section scroll-to-page" id="resume">
        <div className="custom-container">
            <div className="resume-content content-width">
                <div className="section-header">
                    <h4 className="subtitle scroll-animation" data-aos='fade-up'>
                        <i className="las la-briefcase"></i> Resume
                    </h4>
                    <h1 className="scroll-animation" data-aos='fade-up'>Education & <span>Experience</span></h1>
                    <p><a href="../assets/images/portfolio/baccarella-webdev-resume.pdf">View resume</a></p>
                </div>

                <div className="resume-timeline">
                <div className="item scroll-animation" data-aos='fade-right'>
                        <span className="date">September 2024 - Current</span>
                        <h2>Web Developer II - Amazon</h2>
                       
                    </div>
                <div className="item scroll-animation" data-aos='fade-right'>
                        <span className="date">Nov 2023 - May 2024</span>
                        <h2>Developer - Bristol Myers Squibb</h2>
                       
                    </div>
                    <div className="item scroll-animation" data-aos='fade-right'>
                        <span className="date">August 2019 - Nov 2023</span>
                        <h2>Developer (FTE) - Bloomin' Brands</h2>
                        <h2>Jr. Developer (Contract) - Bloomin' Brands</h2>
                       
                    </div>
                    <div className="item scroll-animation" data-aos='fade-left'>
                        <span className="date">July 2018 - May 2019</span>
                        <h2>Jr. Web Developer - Branded Holdings</h2>
                    </div>
                    <div className="item scroll-animation" data-aos='fade-right'>
                        <span className="date">2010 - 2013</span>
                        <h2>B.S. Business Administration & Entrepreneurial Studies - Rider University</h2>
                    </div>
                </div>

            </div>
        </div>
    </section>
  )
}
